// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3JaU2","footer":"ModalInfo_footer__lzeX-"};